import { render, staticRenderFns } from "./UserOrderList.vue?vue&type=template&id=216fefa4"
import script from "./UserOrderList.vue?vue&type=script&lang=js"
export * from "./UserOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports